import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Function to apply the theme to the document
function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

// Function to detect the theme and return it
function detectTheme() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

// Main component to handle theme changes and render the App
function Main() {
  const [theme, setTheme] = useState(detectTheme());
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    applyTheme(theme);

    const handleThemeChange = (event) => {
      const newTheme = event.matches ? 'dark' : 'light';
      setTheme(newTheme);
      applyTheme(newTheme);
    };

    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeMediaQuery.addEventListener('change', handleThemeChange);

    return () => {
      darkModeMediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, [theme]);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const installButton = document.getElementById('installButton');
      if (installButton) {
        installButton.style.display = 'block';
      }
    };

    const handleAppInstalled = () => {
      console.log('PWA was installed');
      const installButton = document.getElementById('installButton');
      if (installButton) {
        installButton.style.display = 'none';
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallButtonClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
      });
    }
  };

  return <App theme={theme} onInstallButtonClick={handleInstallButtonClick} />;
}

// Render the React app
ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById('root')
);

// Register the service worker
registerServiceWorker();

// Suppress specific console warnings
const warn = window.console.warn;
window.console.warn = message => {
  if (/Automatically scrolling/.test(message)) {
    return;
  }
  warn(message);
};



// WEBPACK FOOTER //
// ./src/index.js